import { useEffect } from "react";

const SITE = "https://www.servantage.co.za";
const sel = {
  description: 'meta[name="description"]', ogTitle: 'meta[property="og:title"]', ogDesc: 'meta[property="og:description"]',
  ogUrl: 'meta[property="og:url"]', ogImage: 'meta[property="og:image"]', ogType: 'meta[property="og:type"]',
  twTitle: 'meta[name="twitter:title"]', twDesc: 'meta[name="twitter:description"]', twImage: 'meta[name="twitter:image"]',
};
const DEFAULTS = Object.fromEntries(Object.entries(sel).map(([k, s]) => [k, document.querySelector(s)?.content]));
const put = (k, v) => { const el = document.querySelector(sel[k]); if (el) el.content = v ?? DEFAULTS[k] ?? ""; };
const absUrl = (image) => (image ? (image.startsWith("http") ? image : `${SITE}${image}`) : undefined);

function useTitleAndUrl(title, path, ogTitle) {
  useEffect(() => {
    document.title = title;
    const canon = document.querySelector('link[rel="canonical"]');
    if (canon) canon.href = `${SITE}${path}`;
    put("ogUrl", `${SITE}${path}`);
    put("ogTitle", ogTitle ? title : undefined); put("twTitle", ogTitle ? title : undefined);
  }, [title, path, ogTitle]);
}

function useRobots(noindex) {
  useEffect(() => {
    const robots = document.querySelector('meta[name="robots"]');
    if (robots) robots.content = noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large";
  }, [noindex]);
}

function useSocialMeta(description, image, type) {
  useEffect(() => {
    const img = absUrl(image);
    put("description", description); put("ogDesc", description); put("twDesc", description);
    put("ogImage", img); put("twImage", img); put("ogType", type);
  }, [description, image, type]);
}

function useJsonLd(ld) {
  useEffect(() => {
    if (!ld) { return undefined; }
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.dataset.page = "1";
    script.text = ld;
    document.head.appendChild(script);
    return () => { script.remove(); };
  }, [ld]);
}

export function usePageMeta(title, path = "/", noindex = false, extra = {}) {
  const { description, image, type, jsonLd } = extra;
  useTitleAndUrl(title, path, !!extra.title);
  useRobots(noindex);
  useSocialMeta(description, image, type);
  useJsonLd(jsonLd ? JSON.stringify(jsonLd) : "");
}
